import { useState } from "react";
import "../form.scss";
import React from "react";
import { isNullOrWhitespace } from "../../../../utilities/string";

export interface dateboxProps {
    id: string;
    label: string;
    value: string;
    initializeDefault?: boolean;
    onChange: (newValue: string) => any;
    setFocus?: boolean;
    firstCol?: number;
    disabled?: boolean;
}

const getDefaultDateTime = () => {
    const defaultDate = new Date(Date.now() - new Date().getTimezoneOffset() * 60000);
    defaultDate.setSeconds(0, 0);
    return defaultDate.toISOString().slice(0, -5);
};

function DateTime(props: dateboxProps) {
    const [fieldValue, setFieldValue] = useState("");

    React.useEffect(() => {
        if (props.value === "" && !props.disabled && props.initializeDefault) {
            let defaultVal = getDefaultDateTime();
            setFieldValue(defaultVal);
            props.onChange(defaultVal);
        } else {
            setFieldValue(props.value);
        }
    }, [props.value]);

    const handleInputChange = (e: React.FormEvent<HTMLInputElement>) => {
        setFieldValue(e.currentTarget.value);
        props.onChange(e.currentTarget.value);
    };

    return (
        <div
            className="row rowMarginControl"
            key={"Main" + props.id}
        >
            <div className={props.firstCol == undefined ? "col-sm-3" : "col-sm-" + props.firstCol}>
                <label className="g-label">{props.label}</label>
            </div>
            <div className={props.firstCol == undefined ? "col-sm-9" : "col-sm-" + (12 - props.firstCol)}>
                <input
                    type={props.disabled && isNullOrWhitespace(fieldValue) ? "text" : "datetime-local"}
                    className="g-TextBox-default"
                    onChange={handleInputChange}
                    value={fieldValue}
                    step={60}
                    disabled={props.disabled}
                />
            </div>
        </div>
    );
}
export default DateTime;
